import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import animator from '../../../helpers/animator';
import ProjectHeader from '../ProjectHeader';
import BreadCrumbs from '../../../components/BreadCrumbs';
import TaskCompletionStepsContainer from '../../../components/TaskCRUD/TaskCompletionStepsContainer';
import TaskDetails from '../../../components/TaskCRUD/TaskDetails';
import DataSource from '../../../dao/DataSource/DataSource';

import './TaskDisplay.scss';

const task_display_root = {
  task: {
    completion_criteria: {
      attachments: {
        additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'],
        user: {},
        conversions: {},
      },
      comments: { user: { additionalFields: ['profile_image'] } },
      event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
      form_fields: {},
    },
    reference_documents: {},
    user_task_assignments: {
      user: {
        additionalFields: ['profile_image'],
        companies: {},
      },
    },
    build_owners: { companies: {} },
    inventory_items: { inventory: {} },
    event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
  },
};

function formatDate(date) {
  let formattedDate = null;
  if (date) {
    let dateFormatter = new Date(date);
    let month = dateFormatter.getMonth() + 1;
    if (month < 10) {
      month = '0' + month;
    }
    let day = dateFormatter.getDate();
    if (day < 10) {
      day = '0' + day;
    }
    let year = dateFormatter.getFullYear();
    formattedDate = month + '/' + day + '/' + year;
  }
  return formattedDate;
}

class TaskDisplay extends BaseComponent {
 
  constructor(props) {
    super(props);
    this.animator = new animator();
    const { currentCompany } = props;
    this.state = { menu: null, displayHeight: 0, inventoryItems: [], inventoryEnabled: currentCompany.features && currentCompany.features.inventory && currentCompany.features.inventory.enabled };
  }

  handleTaskUpdate(task, action, acData, fetchedData) {
    if (task) {
      this.setState({ task, inventoryItems: this.buildInventoryItems(task) });
      if (!this.state.build) {
        this.buildDataSource = new DataSource('Build', task.build_id, { build: { tasks: {} } }, this.handleBuildUpdate);
        this.buildDataSource.get();
      }
    }
  }

  handleBuildUpdate(build, action, acData, fetchedData) {
    if (build) {
      this.setState({ build });
    }
  }
  componentDidMount() {
    super.componentDidMount();

    if (this.props.taskId) {
      this.taskDataSource = new DataSource('Task', this.props.taskId, task_display_root, this.handleTaskUpdate);
      this.taskDataSource.get();
    }
  }

  componentWillUnmount() {
    if (this.taskDataSource) {
      this.taskDataSource.release();
      this.taskDataSource = null;
    }
    if (this.buildDataSource) {
      this.buildDataSource.release();
      this.buildDataSource = null;
    }
  }

  buildInventoryItems(task) {
    let inventoryItems = [];
    if (task) {
      inventoryItems = task.inventory_items ?
        task.inventory_items.map(
          inventoryItem => {
            return {
              customer_data: inventoryItem.customer_data,
              id: inventoryItem.id,
              identifier: inventoryItem.identifier,
              name: inventoryItem.inventory.name,
            };
          }
        )
        : [];
    }
    return inventoryItems;
  }

  handleExpansion(height) {
    this.setState({ displayHeight: height + 20, mapExpanded: height > 20 ? true : false });
    if(this.props.handleMapExpansion){
      this.props.handleMapExpansion(height > 0);
    }
  }

  handleSetScrollElement(element) {
    if (element) {
      this.scrollElement = element;
    }
  }

  handleScroll() {
    if (!this.firstScroll && this.scrollElement) {
      this.firstScroll = true;
      this.scrollElement.scrollTop = 0;
    }
  }

  render() {
    const { task, build } = this.state;

    if (!task){
      return null;
    }

    const userProject = this.props.userProject;

    let leftColumn = <TaskCompletionStepsContainer 
      task={task} 
      userProject={userProject}
      build={build}
      view="tasks"
    />;

    let rightColumn = 
    <TaskDetails 
      id={'task-settings-' + task && task.id}
      task={task} 
      project={userProject} 
      inventoryItems={this.state.inventoryItems}
      inventoryEnabled={this.state.inventoryEnabled}
    />;

    let completed = 0;
    let attachmentCount = task.task_attachments_count;
    const total = task.completion_criteria ? task.completion_criteria.length : 0;
    if (total > 0) {
      completed = task.completion_criteria.filter(cc => {
        return cc.completed_at;
      }).length;
    }

    const stepsRejected = this.state.task.completion_criteria ? this.state.task.completion_criteria.filter(cc => {
      return cc.rejected_at && !cc.approved_at && !cc.reviewed_at && !cc.completed_at;
    }) : [];

    let statusName = task.status.split('_').map(word => word.substr(0, 1).toUpperCase() + word.substr(1).toLowerCase()).join(' ');
    let statusStyle = '';

    switch (task.status) {
    case 'not_started':
      statusStyle = 'not-started';
      break;
    case 'in_progress':
      if (stepsRejected.length == 0) {
        statusStyle = 'in-progress';
      }
      else{
        statusStyle = 'in-progress rejected';
        statusName += ' / rejected';
      }
      break;
    case 'pending_review':
      statusStyle = 'pending';
      break;
    case 'pending_approval':
      statusStyle = 'pending';
      break;
    case 'completed':
      statusStyle = 'completed';
      break;
    default: break;
    }

    let taskDate = null;
    if (task.estimated_completion_date || task.actual_completion_date) {
      let calendarIcon = null;
      let taskCompletion = null;
      let estimatedCompletionDate = formatDate(task.actual_completion_date ? task.actual_completion_date : task.estimated_completion_date);
      const overdue = !task.actual_completion_date && new Date(estimatedCompletionDate) < new Date() ? ' overdue' : '';
      const completed = task.status == 'not_started' || task.status == 'in_progress' ? '' : ' completed';
      calendarIcon = <div className={'calendar-icon' + overdue + completed} />;

      taskCompletion = <div className={'icon-text' + overdue}>{estimatedCompletionDate}</div>;
      const whichDatePopup = <div className="which-date-popup">{task.actual_completion_date ? 'Actual Completion Date' : 'Projected Completion Date'}</div>;

      taskDate = <div className='completion-date'>
        {calendarIcon}
        {taskCompletion}
        {whichDatePopup}
      </div>;
    }

    let taskStatus = <div className={'task-status ' + statusStyle }>
      {statusName}
    </div>;

    let taskHeader = <div className="task-header">
      <div className="top-line">
        <div className="task-title">{task.name.toUpperCase()}</div>
      </div>
      <div className="info-icon-row">
        <div className="attachments">
          <div className="attachment-icon" />
          <div className="icon-text">{attachmentCount}</div>
        </div>
        <div className="completion-criteria">
          <div className="completion-icon" />
          <div className="icon-text">{completed + '/' + total}</div>
        </div>
        {taskDate}
        {taskStatus}
      </div>
    </div>;
    
    return (

      <div className="task-display">
        <ProjectHeader 
          projectId={userProject && userProject.id} 
          task={task} 
          build={build}
          type='tasks-page' 
          dontAllowAdd={true} 
          handleExpansion={this.handleExpansion} 
          mapExpanded={this.props.mapExpanded} 
          inProjectsTab={false}
          isLeftDividerHide={true}
        />
        <div className="task-display-container">
          <div className="task-display-subheader" >
            <BreadCrumbs history={this.props.history} fromTasks={true}/>
        </div>
          {taskHeader}  
        {this.state.menu}
          <div className={'task-display-scroller' + (this.state.mapExpanded ? ' display-map' : '')}
            onScroll={this.handleScroll} 
            ref={element => { this.handleSetScrollElement(element); }}>
          <div className="task-display-body">
            <div className="column column-1">
              {leftColumn}
            </div>
            <div className="column-divider" />
            <div className="column column-2">
              {rightColumn}
            </div>
          </div>
          </div>
        </div>
      </div>
    );
  }
}

// Change to appropriate class name

const mapStateToProps = (state, ownProps) => {

  return {
    inProgress: state.main.inProgress,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

export default withRouter(connect(mapStateToProps)(TaskDisplay));



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/TaskDisplay/index.js